import React from 'react';
import { Flame, MapPin, Heart, Award } from 'lucide-react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-stone-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Image/Logo */}
          <div className="relative">
            <div className="bg-gradient-to-br from-amber-500/20 to-stone-900 rounded-3xl p-8 border border-amber-500/20">
              <img
                src="https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/dvye961w_image.png"
                alt="Rotativa Gaúcha Logo"
                className="w-full max-w-md mx-auto"
              />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-amber-500 text-stone-900 px-4 py-2 rounded-xl font-bold shadow-lg">
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                <span>Panambi/RS</span>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="text-amber-500 font-semibold text-sm tracking-wider uppercase">Quem Somos</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-2 mb-6">
              Uma empresa <span className="text-amber-500">pra lá de bagual!</span>
            </h2>
            
            <div className="space-y-4 text-stone-300">
              <p className="text-lg">
                A <span className="text-amber-400 font-semibold">Rotativa Gaúcha</span> nasceu da paixão pelo verdadeiro churrasco gaúcho. Somos de Panambi, no coração do Rio Grande do Sul, e fabricamos churrasqueiras rotativas de alta qualidade.
              </p>
              <p>
                Nossa missão é levar <span className="text-amber-400">tradição, qualidade e durabilidade</span> para o seu churrasco. Cada rotativa é fabricada com cuidado e atenção aos detalhes, garantindo que seu costelão fique perfeito!
              </p>
              <p>
                Enviamos para todo o Brasil com embalagem reforçada, para que sua churrasqueira chegue perfeita. Convide os amigos, a família e faça aquele costelão saboroso e gostoso! 🥩
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Flame className="w-5 h-5 text-amber-500" />
                </div>
                <div>
                  <h4 className="text-white font-semibold">Qualidade</h4>
                  <p className="text-stone-400 text-sm">Materiais de primeira linha</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Heart className="w-5 h-5 text-amber-500" />
                </div>
                <div>
                  <h4 className="text-white font-semibold">Tradição</h4>
                  <p className="text-stone-400 text-sm">Churrasco gaúcho de verdade</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-5 h-5 text-amber-500" />
                </div>
                <div>
                  <h4 className="text-white font-semibold">Garantia</h4>
                  <p className="text-stone-400 text-sm">Produtos com garantia</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-amber-500" />
                </div>
                <div>
                  <h4 className="text-white font-semibold">Panambi/RS</h4>
                  <p className="text-stone-400 text-sm">Fabricação própria</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
